'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // Set locale to moment
    _moment2.default.locale((0, _localize.getCurrentLocale)());
};

var _localize = require('linksoft/core/localize');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/moment.js
// module id = 1074
// module chunks = 1